import CommonUtils from '@/resources/utils/common-utils';
import API from '@/config/api';


const publicModules = {

    state: {

    },

    mutations: {

        getRolePermissionLists(state, data) {
            data.url = API.role.getRolePermissionLists;
            CommonUtils.GetRequest(data);
        },

        getRoleListsNoPagination(state, data) {
            data.url = API.role.getRoleListsNoPagination;
            CommonUtils.GetRequest(data);
        },

        getRoleLists(state, data) {
            data.url = API.role.getRoleLists;
            CommonUtils.GetRequest(data);
        },

        deleteRole(state, data) {
            data.url = API.role.deleteRole;
            CommonUtils.GetRequest(data);
        },

        getRoleInfo(state, data) {
            data.url = API.role.getRoleInfo;
            CommonUtils.GetRequest(data);
        },

        editRole(state, data) {
            data.url = API.role.editRole;
            CommonUtils.PostRequest(data);
        },

        addRole(state, data) {
            data.url = API.role.addRole;
            CommonUtils.PostRequest(data);
        }

    }

};

export default publicModules;


// WEBPACK FOOTER //
// ./src/store/modules/role.js